import React from "react";
import { Col, Row, Form } from "antd";

/**
 *
 * @param {object} param
 * @param {() => void} param.onFinish
 * @param {import('react').ReactNode} param.children
 */
export default function AuthLayout({ children, onFinish, form }) {
  return (
    <>
      <Row justify="center">
        <Col>
          <Form
            form={form}
            initialValues={{ remember: true }}
            style={{ marginTop: 150 }}
            onFinish={onFinish}
          >
            {children}
          </Form>
        </Col>
      </Row>
    </>
  );
}
